export default String.raw`
@charset "UTF-8";

/* ---- globals ---- */
@import 'globals/_global-variables';
@import 'globals/_mixins';
@import 'globals/_globals1';

/* ---- components ---- */
@import 'components/_country-flags.scss';
@import 'components/_pagination';


/* ---- partial pages ---- */
@import 'partials/_home';
`